import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=dd7b0e28&scoped=true&"
import script from "./BookingDetails.vue?vue&type=script&lang=js&"
export * from "./BookingDetails.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&id=dd7b0e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7b0e28",
  null
  
)

export default component.exports